import { CLST } from '../../lib/icons';
import type { ChipItem, NodeCluster } from './model';

type ChipsProps = {
  id: string;
  name: string;
  items: ChipItem[];
  selected: readonly string[];
  onChange: (next: string[]) => void;
};


export function Chips({ id, name, items, selected, onChange }: ChipsProps) {
  const set = new Set(selected);
  return (
    <div className="pr-chips" id={id}>
      {items.map(([value, label]) => (
        <label className="pr-chip" key={value}>
          <input
            type="checkbox"
            name={name}
            value={value}
            checked={set.has(value)}
            onChange={(e) => {
              const next = new Set(set);
              if (e.target.checked) next.add(value);
              else next.delete(value);

              onChange(items.map(([v]) => v).filter((v) => next.has(v)));
            }}
          />
          {label}
        </label>
      ))}
    </div>
  );
}


export function ClusterPill({ c }: { c: NodeCluster }) {
  const statusKey =
    c.status === 'busy' && c.live?.workMode === 'warming'
      ? 'warming'
      : c.status === 'busy' && c.live?.workMode === 'targeting'
        ? 'targeting'
        : c.status;
  const ui = CLST[statusKey] ?? CLST.offline ?? ['stop', 'Оффлайн'];
  const title = c.status === 'deploying' && c.deployStageLabel ? c.deployStageLabel : ui[1];
  const pct = Math.min(100, c.deployProgress ?? 0);
  const lvl = pct >= 85 ? 'er' : pct >= 65 ? 'wa' : '';
  return (
    <>
      <span className={`pill ${ui[0]}`}>
        <span className="led" />
        {title}
      </span>
      {c.status === 'deploying' && (
        <div className={`mbar ${lvl}`}>
          <div className="track">
            <i style={{ width: `${pct.toFixed(1)}%` }} />
          </div>
          <span>{`${c.deployProgress ?? 0}%`}</span>
        </div>
      )}
    </>
  );
}

export function liveClusters(clusters: NodeCluster[]): NodeCluster[] {
  return clusters.filter((c) => c.enabled !== false);
}
